import { Chip, Stack } from "@mui/material";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import XMenu from "../components/basic/XMenu";
import { useDispatch, useSelector } from "react-redux";
import { REQUESTS, LOGOUT } from "../redux/types";
import { useNavigate } from "react-router-dom";
import React from "react";
const ZToolbar = ({ handleDrawerOpen, open, title, customCss }, prop) => {
  let navigate = useNavigate();
  let dispatch = useDispatch();
  let userState = useSelector((state) => state.auth.data)
  React.useEffect(() => { }, [open]);
  return (
    <div {...prop}>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        spacing={2}
        sx={{ px: 1, py: 0.8 }}
      >
        <IconButton
          color="inherit"
          aria-label="open drawer"
          onClick={handleDrawerOpen}
          edge="start"
          sx={{
            marginLeft: 5,
            p: 0,
            ...(open && { display: "none" }),
          }}
        >
          <MenuIcon />
        </IconButton>
        <Box sx={{ flexGrow: 1 }}>
          <Typography sxvariant="h6" noWrap component="div">
            {!open && title}
          </Typography>
        </Box>
        {userState.first_name && <Box sx={{ flexGrow: 0, marginRight: 5 }}>
          {/* <Chip label={"Notifications"} size="small" sx={{ mx: 1, ...customCss.AppBar.Chip }} />
          <Chip label={"Messages"} size="small" sx={{ mx: 1, ...customCss.AppBar.Chip }} />
          <Chip label={userState.first_name + " " + userState.last_name} size="small" sx={{ mx: 1, ...customCss.AppBar.Chip }} /> */}
          <XMenu
            list={["Profile", "Logout"]}
            onClick={(e, action) => {
              if (action == "Logout") {
                dispatch({
                  type: LOGOUT,
                  payload: {}
                });
              }
            }}
          />
        </Box>}
      </Stack>
    </div>
  );
};
export default ZToolbar;
